module.exports = __webpack_public_path__ + "img/icon-cambio-passwd.c2bb82b6.svg";